import { render } from "./Vacaciones.vue?vue&type=template&id=0fccc6b3&ts=true"
import script from "./Vacaciones.vue?vue&type=script&lang=ts"
export * from "./Vacaciones.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__